export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14983.ac7a0020.jpg";